import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IBusquedaUsuarios } from 'src/app/interfaces/usuarios';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { RolesService } from 'src/app/services/roles/roles.service';
import { SedesService } from 'src/app/services/sedes/sedes.service';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';

@Component({
  selector: 'app-view-mantenedor-usuario-editar',
  templateUrl: './view-mantenedor-usuario-editar.component.html',
  styleUrls: ['./view-mantenedor-usuario-editar.component.scss']
})
export class ViewMantenedorUsuarioEditarComponent implements OnInit {
  dtOptions: DataTables.Settings = { ...DatatableConfig.simpledt }
  usuario: IBusquedaUsuarios | any = {}
  roles: any = []
  sedes: any = []
  renderSedesTable: boolean = true
  habilitarTodos: boolean = false
  rolSeleccionado: number = 0;
  rolUsuario: number = 0;
  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  soloVisualizar: boolean = false;
  error: string = "";

  constructor(
    private router: Router,
    private rolService: RolesService,
    private spinner: NgxSpinnerService,
    private sedesService: SedesService,
    private usuarioService: UsuariosService,
    private _perfilamiento: PerfilamientoService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.infoUsuario ) {
      this.usuario = routerData.infoUsuario
    } 
    if ( !routerData ) {
      this.router.navigate(['/usuario-inicio'])
    }
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.simpledt }
    this.getRoles()
  }

  getDetalleUsuario() {
    this.renderSedesTable = false
    let usuario = this._perfilamiento.getUsuario();
    this.usuarioService.configuracionUsuario(this.usuario?.usuarioId).subscribe(
      (res: any) => {
        if ( res?.rolId ) {
          this.rolSeleccionado = res?.rolId
          this.rolUsuario = usuario.rolId;
        }
        if ( res?.sedesId.length > 0 ) {
          let sedesSeleccionadas = [...res.sedesId];
          let cantidadSedesSeleccionadas = sedesSeleccionadas.length;
          let posicionSedes = 0;
          while (posicionSedes < cantidadSedesSeleccionadas) {
            this.sedes.forEach((sede: any) => {
              if (sede.sedeId === sedesSeleccionadas[posicionSedes]) {
                sede.habilitar = true;
              }
            });
            posicionSedes++;

          }
          this.renderSedesTable = true
        }
        if (res?.rolId == 1 && usuario.rolId != 1) {
          this.soloVisualizar = true;
        }
      }
    )
  }

  getSedes() {
    this.renderSedesTable = false
    this.sedesService.getSedes().subscribe(
      (res) => {
        this.sedes = res
        this.renderSedesTable = true
        this.getDetalleUsuario()
      }, err => {
      }
    )
  }

  getRoles() {
    this.rolService.getRoles().subscribe(
      (res: any) => {
        this.roles = res.roles
        this.getSedes()
      }
    )
  }

  habilitarTodosFn(event: any) {
    if ( event.srcElement.checked ) {
      this.sedes.forEach((sede: any) => {
        sede.habilitar = true
      });
    } else {
      this.sedes.forEach((sede: any) => {
        sede.habilitar = false
      });
    }
  }

  checkSede() {
    setTimeout(() => {
      const sedesSeleccionadas = this.sedes.filter((sede: any) => sede.habilitar === true)
      if ( sedesSeleccionadas.length >= this.sedes.length ) {
        this.habilitarTodos = true
      }
      if ( sedesSeleccionadas.length === 0 ) {
        this.habilitarTodos = false
      }
      if ( sedesSeleccionadas.length < this.sedes.length ) {
        this.habilitarTodos = false
      }
    }, 100)
  }

  showInfoModal(titulo: string = '', texto: string = '') {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  validaUsuario() {
    const sedesSeleccionadas = this.sedes.filter((sede: any) => sede.habilitar === true)
    if ( !this.rolSeleccionado || sedesSeleccionadas.length < 1 ) {
      this.showInfoModal('Atención', 'Debes seleccionar un rol y al menos una sede para poder crear el Usuario.')
      return false
    }
    if ( this._perfilamiento.getUsuario().rolId === 1 && this.rolSeleccionado !== 1 && sedesSeleccionadas.length >= this.sedes.length ) {
      this.showInfoModal('Atención', 'Solo el rol Dara Central puede tener todas las sedes habilitadas')
      return false
    }
    return true
  }

  modificarUsuario() {
    
    let usuarioModificador = this._perfilamiento.getUsuario();
    if ( !this.validaUsuario() ) {
      return
    }
    let sedesId: Array<number> = []
    this.sedes.forEach((sede: any) => {
      if ( sede.habilitar ) {
        sedesId = [...sedesId, sede.sedeId]
      }
    })
    const serviceData = {
      usuarioId: this.usuario.usuarioId,
      estadoUsuario: this.usuario.vigente,
      usuarioModificacion: usuarioModificador.username,
      rolId: this.rolSeleccionado,
      sedes: sedesId
    }
    this.usuarioService.modificarUsuario(serviceData).subscribe ({
      next: (res: any) => {
        if (res.error != null) {
          this.error = res.error;
        } else {
          let mensaje = "Los cambios para el usuario " + this.usuario.username + " se realizaron de manera exitosa."
          this.router.navigate(['/usuario-inicio'], { state: { data: { usuarioModificado: true, mensaje: mensaje } } })
        }
      }
    }
    )
  }
}
